import { makeStyles } from '@fluentui/react-components';
import { memo } from 'react';
import { graphql, usePreloadedQuery } from 'react-relay';
import { MessageBarGroup } from '../message-bar-group/MessageBarGroup';
import { ModelerProvider } from '../modeler/react/context/ModelerContext';
import { useModelerIsDirtyContext } from '../modeler/react/context/useModelerIsDirtyContext';
import { ModelerIsDirtyProvider } from '../modeler/react/context/ModelerIsDirtyContext';
import { NavigationBlocker } from '../navigation/NavigationBlocker';
import type { processDefinitionQuery } from './__generated__/processDefinitionQuery.graphql';
import { ProcessDefinitionToolbar } from './process-definition-toolbar';
import { ProcessDefinitionModeler } from './process-definition-modeler';
import { processDefinitionRouteApi } from './process-definition-api';
import {
    ProcessDefinitionQueryCtx,
    useProcessDefinitionQueryFragment,
} from './process-definition-query';

const useStyles = makeStyles({
    header: {
        display: 'grid',
        gap: '1em',
    },
    root: {
        display: 'grid',
        gap: '1em',
        gridTemplateRows: 'auto 1fr',
    },
});

export const ProcessDefinition = memo(() => {
    const styles = useStyles();
    return (
        <div className={styles.root}>
            <ModelerProvider>
                <ModelerIsDirtyProvider>
                    <QueryProvider />
                </ModelerIsDirtyProvider>
            </ModelerProvider>
        </div>
    );
});
ProcessDefinition.displayName = 'ProcessDefinition';

const QueryProvider = () => (
    <ProcessDefinitionQueryCtx.Provider
        value={
            usePreloadedQuery<processDefinitionQuery>(
                query,
                processDefinitionRouteApi.useLoaderData()
            ).getProcessDefinition
        }
    >
        <ProcessDefinitionHeader />
        <ProcessDefinitionModeler />
        <NavigationBlocker
            useData={useProcessDefinitionQueryFragment}
            useIsDirty={useModelerIsDirtyContext}
        />
    </ProcessDefinitionQueryCtx.Provider>
);

const query = graphql`
    query processDefinitionQuery($id: ID!) {
        getProcessDefinition(id: $id) {
            ...processDefinitionQueryFragment
        }
    }
`;

const ProcessDefinitionHeader = memo(() => {
    const styles = useStyles();
    return (
        <div className={styles.header}>
            <MessageBarGroup />
            <ProcessDefinitionToolbar />
        </div>
    );
});
ProcessDefinitionHeader.displayName = 'ProcessDefinitionHeader';
